import db from '../../firebase/firebaseInit';

export default {
  state: {
    todos: []
  },

  getters: {
    allTodos: (state) => state.todos,
    alleNormaleTodos: (state) => state.todos.filter((todo) => !todo.belangrijk && !todo.klaar),
    alleBelangrijkeTodos: (state) => state.todos.filter((todo) => todo.belangrijk && !todo.klaar),
    alleAfgerondeTodos: (state) => state.todos.filter((todo) => todo.klaar)
  },

  mutations: {
    setTodos: (state, todos) => (state.todos = todos),
    deleteTodo: (state, todos) => (state.todos = todos)
  },

  actions: {
    // live con db todos
    async fetchTodos() {
      let list = [];
      db.collection('todos').onSnapshot((res) => {
        const changes = res.docChanges();
        changes.forEach((change) => {
          const { newIndex, oldIndex } = change;
          if (change.type === 'added') {
            const data = {
              id: change.doc.id,
              ...change.doc.data()
            };
            list.push(data);
          } else if (change.type === 'modified') {
            list.splice(oldIndex, 1);
            var newdata = {
              id: change.doc.id,
              ...change.doc.data()
            };
            list.splice(newIndex, 0, newdata);
          } else if (change.type === 'removed') {
            list.splice(oldIndex, 1);
          }
          this.commit('setTodos', list);
        });
      });
    },

    // voeg todo toe in todos in db
    async voegTodoToe(context, payload) {
      try {
        db.collection('todos')
          .doc((context.state.todos.length + 1).toString())
          .set({
            todo: payload.todo,
            klaar: false,
            belangrijk: payload.belangrijk
          })
          .then(function() {
            console.log('todo toegevoegd in todos in db');
          });
      } catch (error) {
        console.error('Error writing document: ', error);
        alert('Opslaan niet gelukt... Probeer het opnieuw of neem contact op met Christiaan');
      }
    },

    // verwijder toe uit todos in db
    async verwijderTodo(context, payload) {
      try {
        db.collection('todos')
          .doc(payload)
          .delete()
          .then(function() {
            console.log('todo verwijderd uit todos in db');
          });
      } catch (error) {
        console.error('Error deleting document: ', error);
        alert('Verwijderen niet gelukt... Probeer het opnieuw of neem contact op met Christiaan');
      }
    },

    // zet 'belangrijk' van todo op 'true'
    async toggleBelangrijk(context, payload) {
      try {
        db.collection('todos')
          .doc(payload.id)
          .update({
            belangrijk: !payload.belangrijk
          })
          .then(function() {
            console.log('todo.belangrijk is gezet op: ' + !payload.belangrijk + ' in db');
          });
      } catch (error) {
        console.error('Error deleting document: ', error);
        alert('Updaten todo is niet gelukt... Probeer het opnieuw of neem contact op met Christiaan');
      }
    },

    // toggle 'klaar' van todo op '!toggle.klaar'
    async toggleKlaar(context, payload) {
      try {
        db.collection('todos')
          .doc(payload.id)
          .update({
            klaar: !payload.klaar
          })
          .then(function() {
            console.log('todo.klaar is gezet op: ' + !payload.klaar + ' in db');
          });
      } catch (error) {
        console.error('Error deleting document: ', error);
        alert('Updaten todo is niet gelukt... Probeer het opnieuw of neem contact op met Christiaan');
      }
    }
  }
};
